import { COLOR_VALUES } from "shared/config/colors";
import { getMoneyColumnVal } from "shared/helper-functions/format/formatCurrency";

// Accumulates numeric values from each data row into the corresponding cells of arr,
// starting at the offset defined by totalsStrColmAtStart.
export const getSum = (totalOneColumns, totalsStrColmAtStart, data, arr) => {
    data?.forEach((item) => {
        totalOneColumns.forEach((column, i) => {
            if (item[column]) {
                arr[i + totalsStrColmAtStart].text += item[column];
            }
        });
    });
};

// Updates arr cells with formatted currency values pulled from summaryData.
// Applies orange text color to negative amounts.
export const updateArrayWithCurrency = (
    symbol,
    summaryData,
    totalOneColumns,
    moneyArr,
    totalsStrColmAtStart
) => {
    totalOneColumns.forEach((column, i) => {
        const amt = summaryData[column];
        moneyArr[i + totalsStrColmAtStart].text =
            typeof amt === "number" ? getMoneyColumnVal(symbol, amt) : `-`;
        moneyArr[i + totalsStrColmAtStart].textColor =
            typeof amt === "number" && amt < 0 ? COLOR_VALUES.Orange_1 : null;
    });
};

// Same as updateArrayWithCurrency but reads the amount from the existing arr cell text
// instead of summaryData. Used when values were previously accumulated with getSum.
export const updateArrayWithCurrencyForSum = (
    symbol,
    totalOneColumns,
    moneyArr,
    totalsStrColmAtStart
) => {
    totalOneColumns.forEach((_column, i) => {
        const amt = moneyArr[i + totalsStrColmAtStart]?.text;
        moneyArr[i + totalsStrColmAtStart].text =
            typeof amt === "number" ? getMoneyColumnVal(symbol, amt) : `-`;
        moneyArr[i + totalsStrColmAtStart].textColor =
            typeof amt === "number" && amt < 0 ? COLOR_VALUES.Orange_1 : null;
    });
};

// Formats the numeric text of each target cell in hoursArr to 2 decimal places.
// Cells with non-numeric values are set to "-".
export const updateArrayWithToFixed = (
    totalOneColumns,
    hoursArr,
    totalsStrColmAtStart
) => {
    totalOneColumns.forEach((_column, i) => {
        hoursArr[i + totalsStrColmAtStart].text =
            typeof hoursArr[i + totalsStrColmAtStart]?.text === "number"
                ? hoursArr[i + totalsStrColmAtStart].text.toFixed(2)
                : "-";
    });
};
